import './Clients.css';

const clients = [
  { name: 'EZ Offers',            logo: '/clients/ez-offers.png'          },
  { name: 'GreenLeaf Organics',   logo: '/clients/greenleaf-organics.png' },
  { name: 'BuildCraft',           logo: '/clients/buildcraft.png'         },
  { name: 'AK Groups',            logo: '/clients/ak-groups.png'          },
  { name: 'Blussh',               logo: '/clients/blussh.png'             },
  { name: 'TechVision Solutions', logo: '/clients/techvision.png'         },
];

// Duplicate for seamless infinite marquee
const track = [...clients, ...clients, ...clients];

export default function Clients() {
  return (
    <section className="clients-section">
      <div className="clients-label">
        <span>Our Best Clients</span>
        <div className="clients-line" />
        <span className="clients-trust-badge">Trusted by 50+ brands</span>
      </div>

      <div className="clients-marquee-wrap">
        <div className="clients-track">
          {track.map((c, i) => (
            <div key={i} className="client-logo-card">
              <img src={c.logo} alt={c.name} className="client-logo-img" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
